module.exports = __webpack_public_path__ + "static/media/glanum_kenotaph.d6fedf81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_kenotaph.png
// module id = 717
// module chunks = 0